import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const NewCaledonia = () => {
    return <SharedDocumentsComponent permissionId="44" path="Nova Caledônia" />
}